import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("summit_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("summit_token", t);
  else localStorage.removeItem("summit_token");
};

export const getToken = () => localStorage.getItem("summit_token");

export const fileToBase64 = (file) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => {
      const result = r.result || "";
      const idx = String(result).indexOf("base64,");
      res(idx >= 0 ? String(result).slice(idx + 7) : String(result));
    };
    r.onerror = rej;
    r.readAsDataURL(file);
  });
